module.exports = __webpack_public_path__ + "img/banner-left.c2aa9c2e.svg";